// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer   viewBox="0 0 24 24" {...rest} unit={unit}>
		<path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10
		 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373
		  12-12-5.373-12-12-12zm6 13h-12v-2h12v2z"/>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/MinusBordered.js